import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSaltoSpaceDisconnectedUsersRequest = {
  buildingId: number
}

export type SaltoSpaceDisconnectedUser = {
  saltoUserId: string
  name: string
}

export const getSaltoSpaceDisconnectedUsersQueryKey = (
  data: GetSaltoSpaceDisconnectedUsersRequest,
) => ['useGetSaltoSpaceDisconnectedUsers', data]

const getSaltoSpaceDisconnectedUsers = async (data: GetSaltoSpaceDisconnectedUsersRequest) => {
  const response = await authAPI.get<SaltoSpaceDisconnectedUser[]>(
    `/salto-space/disconnected/${data.buildingId}`,
  )
  return response.data
}

export const useGetSaltoSpaceDisconnectedUsers = (
  data: GetSaltoSpaceDisconnectedUsersRequest,
  enabled = false,
) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getSaltoSpaceDisconnectedUsers(data),
    queryKey: getSaltoSpaceDisconnectedUsersQueryKey(data),
  })
